import { render, staticRenderFns } from "./zxeditor.vue?vue&type=template&id=5923d4b8&scoped=true&"
import script from "./zxeditor.vue?vue&type=script&lang=js&"
export * from "./zxeditor.vue?vue&type=script&lang=js&"
import style0 from "./zxeditor.vue?vue&type=style&index=0&id=5923d4b8&scoped=scoped&lang=css&"
import style1 from "./zxeditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923d4b8",
  null
  
)

export default component.exports